import { useState, useEffect } from "react";
import Button from "../HomePage/Button";
import { useStudioErstellen } from "../../store/studioErstellenStore";

import ErrorMessage from "./ErrorMessage";
import classes from "./Amenities.module.css";

export const Amenities = ({ validate }) => {
    const availableAmenities = [
        "WLAN", "Küche", "Heizung", "Klimaanlage", "Kostenloser Parkplatz", "Umkleiden", 
        "Badezimmer/WC", "Schalldämmung", "Outdoor Bereich",
        "Rollstuhl-Zugang"
    ];

    const { studioData, updateStudioData } = useStudioErstellen();
    const [selectedAmenities, setSelectedAmenities] = useState(studioData.selectedAmenities || []);
    const [errors, setErrors] = useState({
        name: ""
    });

    useEffect(() => {
        if (studioData.selectedAmenities) {
            setSelectedAmenities(studioData.selectedAmenities);
        }
    }, [studioData.selectedAmenities]);

    const toggleAmenity = (amenity) => {
        const newSelectedAmenities = selectedAmenities.includes(amenity)
            ? selectedAmenities.filter(t => t !== amenity)
            : [...selectedAmenities, amenity];
            
        setSelectedAmenities(newSelectedAmenities);
        updateStudioData('selectedAmenities', newSelectedAmenities);
    };

    const handleValidation = () => {
        // Amenities are optional, so always return true
        return true;
    };

    useEffect(() => {
        validate.current = handleValidation;
    }, [validate, selectedAmenities]);

  return (
    <div className={classes.mainContainer}>
        <div className={classes.titleContainer}>
            <h2 className={`${classes.title} titleSemibold`}>Grundausstattung</h2>
            <span className={`${classes.text} slimRegularLarge`}>
                Wähle aus, was in deinem Studio vorhanden ist.
            </span>
        </div>
        <div className={classes.bottomContainer}>
            {availableAmenities.map((amenity) => 
                <div key={amenity} className={classes.suggestionsContainer}>
                    <Button
                        onClick={() => toggleAmenity(amenity)}
                        text={amenity}
                        activebutton={selectedAmenities.includes(amenity)}
                    />
                </div>
            )}
        </div>
        {errors.name && <ErrorMessage>{errors.name}</ErrorMessage>}
    </div>
  );
};

export default Amenities;